import { useAxios } from 'hooks/useAxios';
import { AxiosErrorHandler } from 'shared/Helpers';
import { BASE_URL_V2 } from 'shared/constants';
import { PortfolioCompany } from '../models/Portfolio';

export const usePortfolioApi = () => {
  const { axios } = useAxios(BASE_URL_V2);

  /**
   * Fetches the list of portfolio companies for a specific profile.
   *
   * This function sends an asynchronous HTTP GET request to retrieve portfolio companies
   * associated with the given profile ID. If no profile ID is provided, it attempts to
   * fetch all available portfolio companies.
   * @param {number} [profileId] - The optional ID of the profile to fetch portfolio companies for.
   * @returns {Promise<PortfolioCompany[] | undefined>} A promise that resolves to an array of portfolio companies
   *                                                    or undefined if an error occurs.
   */
  const fetchPortfolioCompanies = async (profileId?: number): Promise<PortfolioCompany[] | undefined> => {
    try {
      const res = await axios.get(`/clients/portfolio`, {
        params: { profileId }
      });
      return res.data;
    } catch (e) {
      await AxiosErrorHandler(e);
    }
  };

  return {
    fetchPortfolioCompanies
  };
};
